@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.favorites

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.favoritepoints.FavoritePointDto


object UpsertPassengerFavoritePointEndpoint :
    EndPoint<UpsertPassengerFavoritePointEndpoint.Request, UpsertPassengerFavoritePointEndpoint.Response>() {
    class Request(
        val favoritePoint: FavoritePointDto
    )

    class Response (
        val existingFavoritePoint: FavoritePointDto? = null
    )

    const val FAVORITE_POINT_ALREADY_EXISTS = "1"
}